import React from "react";
import { config } from "../../config";

const getSize = (size) => {
    switch (size) {
        case "2":
            return "120x120";
        case "3":
            return "150x150";
        default:
            return "105x105";
    }
};

const Credential = ({ id, qrcode, name, role, company, qrcodePosition = "left", qrcodeSize = "1" }) => {
    const hasQr = Boolean(qrcode);
    const qrSize = getSize(qrcodeSize);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
            }}
        >
            {/* QRCode à esquerda */}
            {hasQr && qrcodePosition === "left" && (
                <div
                    style={{
                        flex: "0 0 40%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px",
                    }}
                >
                    <img
                        src={`${config.QRCODE_HOST}/?size=${qrSize}&data=${id}`}
                        alt={`${id}`}
                        style={{ maxWidth: "100%", height: "auto" }}
                    />
                </div>
            )}

            {/* Conteúdo central */}
            <div
                style={{
                    flex: hasQr ? "0 0 60%" : "0 0 100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                    textAlign: "center",
                }}
            >
                {name && (
                    <div
                        style={{
                            fontSize: "20px",
                            fontWeight: "700",
                        }}
                    >
                        {name}
                    </div>
                )}
                {(role || company) && (
                    <div style={{ marginTop: "5px" }}>
                        {company && (
                            <p
                                style={{
                                    fontWeight: "600",
                                    textTransform: "capitalize",
                                    margin: "2px 0",
                                }}
                            >
                                {company}
                            </p>
                        )}
                        {role && (
                            <p
                                style={{
                                    fontSize: "16px",
                                    fontStyle: "italic",
                                    margin: "2px 0",
                                }}
                            >
                                {role.substring(0, 80)}
                            </p>
                        )}
                    </div>
                )}
            </div>

            {/* QRCode à direita */}
            {hasQr && qrcodePosition === "right" && (
                <div
                    style={{
                        flex: "0 0 40%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px",
                    }}
                >
                    <img
                        src={`${config.QRCODE_HOST}/?size=${qrSize}&data=${id}`}
                        alt={`${id}`}
                        style={{ maxWidth: "100%", height: "auto" }}
                    />
                </div>
            )}
        </div>
    );
};

export default Credential;
